import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    redirect: false
};

const newPasswordStart = (state, action) => {
    return updateObject(state, {loading: true, error: null})
};

const newPasswordSuccess = (state, action) => {
    return updateObject(state, {
        error: null,
        loading: false,
        redirect: true
    })
};

const newPasswordFail = (state, action) => {
    return updateObject(state, {
            error: action.error,
            loading: false,
            redirect: false
        }
    )
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NEW_PASSWORD_START:
            return newPasswordStart(state, action);
        case actionTypes.NEW_PASSWORD_SUCCESS:
            return newPasswordSuccess(state, action);
        case actionTypes.NEW_PASSWORD_FAIL:
            return newPasswordFail(state, action);
        default:
            return state;
    }
};

export default reducer;